import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RichTextEditorModule } from "@webapp/shared/rich-text-editor/rich-text-editor.module";
import { UiModule } from "@webapp/ui/ui.module";
import { NoReflectionsComponent } from "./components/no-reflections/no-reflections.component";
import { CadencePagerComponent } from "./components/cadence-pager/cadence-pager.component";
import { CadencePagerDatePipe } from "./pipes/cadence-pager-date.pipe";
import { ReflectionContributorListComponent } from "./components/reflection-contributor-list/reflection-contributor-list.component";
import { TeamReflectionsComponent } from "./components/team-reflections/team-reflections.component";
import { ReflectionDetailsComponent } from "./components/reflection-details/reflection-details.component";
import { ManageReflectionsComponent } from "./components/manage-reflections/manage-reflections.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ManageReflectionQuestionsComponent } from "./components/manage-reflections/manage-question/manage-question.component";
import { ManageReflectionScheduleComponent } from "./components/manage-reflections/manage-schedule/manage-schedule.component";
import { ReflectionFormComponent } from "./components/reflection-form/reflection-form.component";
import { SharedModule } from "@webapp/shared/shared.module";

@NgModule({
  declarations: [
    TeamReflectionsComponent,
    ReflectionContributorListComponent,
    ReflectionDetailsComponent,
    ReflectionFormComponent,
    ManageReflectionsComponent,
    NoReflectionsComponent,
    CadencePagerComponent,
    CadencePagerDatePipe,
    ManageReflectionQuestionsComponent,
    ManageReflectionScheduleComponent,
  ],
  imports: [CommonModule, UiModule, RichTextEditorModule, FormsModule, ReactiveFormsModule, SharedModule],
})
export class ReflectionsModule {}
